/**
 * The predicate every rung of Kelly's Escape ladder opens with.
 * One definition, so a rung cannot quietly disagree with the rungs above and below it about what counts as
 * an Escape.
 */

import type { KeyboardEvent } from "react"

type EscapeCandidate = Pick<KeyboardEvent<Element>, "defaultPrevented" | "key" | "which">

/**
 * An Escape no descendant has claimed. `defaultPrevented` is how a rung claims one; `which === 229` is the
 * Escape that is only cancelling an IME composition, which must never close anything.
 */
export function isUnclaimedEscape(event: EscapeCandidate): boolean {
  return !event.defaultPrevented && event.key === "Escape" && event.which !== 229
}
